import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetMenu extends Http {
  [x: string]: any

  public async getMenu(params: NLoginApi.GetMenuRequestData) {
    return await super.request<NLoginApi.GetMenuResponse>({
      url: '/crossbowSystem/auth/permission/list',
      method: RequestType.Get,
      headers: {
        'Content-Type': 'application/json'
      },
      params
    })
  }
}

export default GetMenu
